import React from 'react';
import { getNotificationNumber } from '../../../functions/Functions';
import { useSelector } from 'react-redux';
import { IAllStates } from '../../../../store/rootReducer';
import { useTranslation } from 'react-i18next';

interface IMenuLink {
    tab: any;
    activeTabKey: string;
    handleChange: any;
}

export default function MenuLink({ tab, activeTabKey, handleChange }: IMenuLink) {
    const { t } = useTranslation();

    const { tabKey, title, icon: IconComponent } = tab;
    const { redDots } = useSelector((state: IAllStates) => state.redDots);

    return (
        <div
            className="tab text-center cursor-pointer position-relative"
            onClick={e => {
                handleChange(e, tabKey);
            }}
        >
            <div
                className={`${
                    activeTabKey !== tabKey ? 'bg-white' : 'bg-primary'
                } p-2 default-radius w-max-content m-auto`}
            >
                {IconComponent && (
                    <IconComponent
                        size={16}
                        width="16"
                        height="16"
                        color={`${activeTabKey !== tabKey ? '#9ea5ab' : '#fff'}`}
                    />
                )}
            </div>
            <p className="font-10">{t(title)}</p>
            {!!getNotificationNumber(tabKey, redDots) && (
                <span className="sidebar-bullet" style={{ right: 0 }}>
                    {getNotificationNumber(tabKey, redDots)}
                </span>
            )}
        </div>
    );
}
